module.exports = __webpack_public_path__ + "img/LabyCreators300x300.7353c86b.png";